<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    price: {
      type: Number,
      required: true,
    },
    leads: {
      type: Number,
      required: true
    },
    is_actual_plan: {
      type: Boolean,
      required: true
    },
    users: {
      type: Number,
      required: true,
    },
    is_enterprise_plan: {
      type: Boolean,
      required: false,
      default: false,
    },
    clickUrl: {
      type: String,
      required: true
    }
  },
  computed: {
    btnVariant() {
      const variant = {
        actual: {
          class: 'actual',
          text: this.__('Plano Atual'),
          disabled: true
        },
        default: {
          class: 'default',
          text: this.__('Selecionar'),
          disabled: false,
        }
      };

      if (this.is_actual_plan) return variant.actual; // é o plano atual

      return variant.default; // não é plano atual
    },
    usersText() {
      return this.users == 0 ? this.__('Usuários ilimitados') : `${this.__('Até')} ${this.users} ${this.__('usuários')}`;
    },
    priceText() {
      let priceText = '';
      if (this.price >= 1) {
        if (Number.isInteger(this.price)) {
          priceText = this.price.toString();
        } else priceText = this.price.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }

      return priceText;
    },
    leadsText() {
      const leadsFormated = this.leads.toLocaleString('pt-BR');
      return this.is_enterprise_plan ? `${this.__('Mais de')} ${leadsFormated} leads` : `${this.__('Até')} ${leadsFormated} leads`;
    }
  },
  methods: {
    redirectUrl: function () {
      if(this.is_enterprise_plan) {
        return window.open(this.clickUrl, '_blank');
      }

      return window.location.href = this.clickUrl;

    }
  },
}
</script>

<template>
  <div class="col-xm-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 p-3 d-flex card">
    <div class="card-body">
      <h3 class="card-title mb-3">{{ this.name }}</h3>
      <div class="price">
        <template v-if="price >= 1">
          R$ <span class="price-number">{{ this.priceText }}</span>/mês
        </template>
        <template v-else>
          <span class="price-number">
            {{ __('Consultar') }}
          </span>
        </template>
      </div>
      <ul class="benefits">
        <li class="lead-limit"> <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
            viewBox="0 0 18 18">
            <path
              d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0" />
            <path
              d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z" />
          </svg>
          {{ leadsText }}
        </li>
        <li> <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 18 18">
            <path
              d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0" />
            <path
              d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z" />
          </svg> {{ usersText }}</li>
      </ul>
      <button @click="redirectUrl" :disabled="this.btnVariant.disabled"
        :class="`btn btn-primary btn-block btn-plan-${this.btnVariant.class}`">{{
        this.btnVariant.text }}</button>
    </div>
  </div>
</template>

<style scoped>
.card {
  -webkit-box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.1);
  border-radius: 24px;
  max-width: 260px;
  padding-right: 24px !important;
  padding-left: 24px !important;
}

.card-body {
  padding: 16px 0 16px 0;
}

.card-title {
  font-weight: 700;
  border-bottom: 1px solid var(--salesflow-primary);
  margin-bottom: 32px !important;
}

div.price {
  color: var(--salesflow-primary-hover) !important;
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 32px;
}

span.price-number {
  font-size: 32px;
}

ul.benefits {
  list-style: none;
  margin: 0 0 32px 0;
  padding: 0;
}

ul.benefits>li {
  padding: 0;
  font-size: 16px;
}

ul.benefits>li:first-child {
  margin-bottom: 32px;
}

ul.benefits>li.lead-limit {
  font-weight: 700;
}

ul.benefits>li>svg {
  fill: var(--salesflow-secondary-hover);
}

.btn-plan-default {
  background: none;
  border: 1px solid var(--salesflow-primary);
  color: var(--salesflow-primary);
}

.btn-plan-default:hover {
  background: var(--salesflow-primary);
  color: white;
}

.btn-plan-actual {
  color: var(--salesflow-font-gray);
  background: var(--salesflow-outline-gray-light);
}
</style>
